<p-dialog #dialog [header]="'Chỉnh sửa CTV'" [(visible)]="isShow" [modal]="true"
  [styleClass]="'ag-modal force-full-width'" [style]="{'width': '1200px'}" closeIcon="ci ci-close"
  maximizeIcon="ci ci-maximize" minimizeIcon="ci ci-minimize" [maximizable]="true" [autoZIndex]="true">
  <p-confirmDialog 
    key="positionDialog" 
    [position]="'center'" 
    rejectButtonStyleClass="p-button-outlined" />
  <div class="col-12 md:col-12">
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>
      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="unitCode">{{'Users.unitCode' | translate}}<span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.unitCode" formControlName="unitCode"> -->
          <p-dropdown [options]="listUnit" [(ngModel)]="itemDetail.unitCode" [filter]="true" filterBy="label,value" appendTo="body" [readonly]="true"
            [virtualScroll]="true" [virtualScrollItemSize]="10"
            formControlName="unitCode">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="salesAssociateCode">{{'Users.llbCode' | translate}}<span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.salesAssociateCode" formControlName="salesAssociateCode" [readOnly]="true">
        </div>
        <div class="field col-12 md:col-6">
          <label for="displayName">{{'Users.displayName' | translate}}<span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.displayName" formControlName="displayName" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="dateOfBirth">{{'Users.dateOfBirth' | translate}}<span style="color: red;">*</span></label>
          <p-calendar [showIcon]="true" [(ngModel)]="itemDetail.dateOfBirth" formControlName="dateOfBirth" [readonlyInput]="isDisable"
            appendTo="body" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy">
          </p-calendar>
        </div>
        <div class="field col-12 md:col-6">
          <label for="citizenId">{{'Users.idNumber' | translate}}<span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.citizenId" formControlName="citizenId" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="phoneNumber">{{'Users.phoneNumber' | translate}}<span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.phoneNumber" formControlName="phoneNumber" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="address">{{'Users.address' | translate}}</label>
          <input type="text" pInputText [(ngModel)]="itemDetail.address" formControlName="address" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="email">{{'Users.email' | translate}}</label>
          <input type="text" pInputText [(ngModel)]="itemDetail.email" formControlName="email" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="gender">{{'Users.gender' | translate}}<span style="color: red;">*</span></label>
          <p-dropdown [options]="listGender" [(ngModel)]="itemDetail.gender" [filter]="true" filterBy="label,value" appendTo="body" [readonly]="isDisable"
            formControlName="gender">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="socialInsuranceCode">{{'Users.socialInsuranceCode' | translate}}</label>
          <input type="text" pInputText [(ngModel)]="itemDetail.socialInsuranceCode" formControlName="socialInsuranceCode" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="location">{{'Users.location' | translate}}</label>
          <input type="text" pInputText [(ngModel)]="itemDetail.location" formControlName="location" [readOnly]="isDisable">
        </div>
        <!-- <div class="field col-12 md:col-6">
          <label for="userName">{{'Users.userName' | translate}}<span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.userName" formControlName="userName">
        </div> -->
        <div class="field col-12 md:col-6">
          <label for="notes">{{'Users.note' | translate}}</label>
          <input type="text" pInputText [(ngModel)]="itemDetail.notes" formControlName="notes" [readOnly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="status">{{'Users.status' | translate}}<span style="color: red;">*</span></label>
          <p-dropdown [options]="listStatus" [(ngModel)]="itemDetail.status" [filter]="true" filterBy="label,value" appendTo="body" [readonly]="isDisable"
            [virtualScroll]="true"
            formControlName="status">
          </p-dropdown>
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="col-12 md:col-12">
      <div class="col-8 md:col-8 fl h-text-left">
        <!-- <button pButton pRipple type="button" label="{{'BUTTON.DELETE' | translate}}" icon="pi pi-trash"
          [disabled]="submitting" class="p-button-danger mr-2 mb-2" (click)="delete()"
          ></button> -->
      </div>

      <div class="col-4 md:col-4 fr">
        <button *ngIf="!isDisable" pButton pRipple type="button" label="{{'BUTTON.SAVE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="saveAndClose()"
          ></button>
      </div>
    </div>
  </p-footer>
</p-dialog>
